import ObjectListStore from "./ObjectList";
import {action, observable} from 'mobx';
import {toast} from "react-toastify";
import FormStore from "./FormStore";
import api from "./api";
import {downloadFile, getBlob} from "../utils/pdf";

class ClaimsListStore extends ObjectListStore {

    CLAIMS_DEFAULT = {
        ...this.DEFAULT,
        filters:{
            ...this.DEFAULT.filters,
            q: null,
            size: 10,
            fromDate: null,
            toDate: null,
            order_by: 'claimReceivedTs',
            clientProfileIds: [],
        }
    }

    REPORT_FORM_DEFAULT = {
        startDate: null,
        endDate: null,
    }

    @observable fetching = false;
    @observable uploading = false;
    @observable uploadErrors = null;


    constructor(api) {
        super(api);
        this.baseUrl = '/insurance/claims';
        this.headers = [
          { name: 'received_date', label: 'Received Date' },
          { name: 'shipment_id', label: 'Shipment ID' },
          { name: 'commodity_type', label: 'Commodity Type' },
          { name: 'claim_value', label: 'Claim Value' },
          { name: 'customer_name', label: 'Customer Name', canBlur: true },
          { name: 'customer_address', label: 'Address', canBlur: true },
          { name: 'submitted_date', label: 'Submitted Date' },
          { name: 'claim_number', label: 'Claim Number' },
          { name: 'claim_status', label: 'Status' },
          { name: 'paid_date', label: 'Est Payment Date' },
          { name: 'paid_amount', label: 'Amount' },
          { name: 'brand_name', label: 'Brand Name' },
        ];
        this.reset();
    }

    // Override parent's reset() method - don't redecorate with @action
    reset() {
        this.setData({
            ...this.CLAIMS_DEFAULT,
            headers: this.headers
        });
        this.reportForm = new FormStore(this);
        this.reportForm.data = { ...this.REPORT_FORM_DEFAULT };
    }

    @action refreshClaim(shipmentId){
        this.searching = true;
        const url = `/insurance/${shipmentId}/claim-status`;
        this.api.get(url)
            .then(response => {
                if (response.status == 200){
                    this.result.items = this.result.items.map((item) => {
                        if(item.shipment_id == shipmentId){
                            return response.data;
                        }
                        return item;
                    });
                }else{
                    toast.error('An error occurred while updating the claim. Please try again.');
                }
            }).catch((e) => {
            toast.error('An error occurred while updating the claim. Please try again.');
            this.error = e;
        }).finally(() => {
            this.searching = false;
        });
    }

    @action
    uploadClaimDocuments(stagedFiles, shipmentId,  claimNumber, success, error){
        this.uploading = true;
        const formData = new FormData();

        stagedFiles.forEach((file) => {
            formData.append('claim_upload_document', file.file);
            formData.append('claim_upload_document_type', file.claimUploadDocumentType);
        });

        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        const url = `/insurance/${shipmentId}/claim/${claimNumber}/upload`;
        const defaultError = 'An error occurred while uploading documents. Please try again.';
        this.api.post(url, formData, config)
            .then(response => {
                if (response.status == 200){
                    //update list
                    this.result.items = this.result.items.map((item) => {
                        if(item.shipment_id == shipmentId){
                            return response.data;
                        }
                        return item;
                    });
                    toast.success('Document(s) uploaded successfully.');
                    success(response.data);
                }else{
                    if(response.data?.errors?.length > 0){
                        error && error(response.data.errors[0]);
                        toast.error(response.data.errors[0]);
                    }else{
                        error && error(defaultError);
                        toast.error(defaultError);
                    }
                }
            }).catch((e) => {
                error && error(defaultError);
                toast.error(defaultError);
                this.uploadErrors = e;
        }).finally(() => {
            this.uploading = false;
        });
    }

    @action
    downloadReport = () => {
        this.fetching = true;
        const url = `/insurance/claims/report`;
        this.api.post(url)
            .then(response => {
                if (response.status !== 200){
                    toast.error('An error occurred while updating the claim. Please try again.');
                }
            }).catch((e) => {
            toast.error('An error occurred while updating the claim. Please try again.');
            this.error = e;
        }).finally(() => {
            this.searching = false;
        });
    }

    getUploadedDocument = (claim, file, download) => {
        this.fetching = true;
        const {shipment_id, claim_number} = claim || {};
        const { name } = file || {};
        api.get(`/insurance/${shipment_id}/claim/${claim_number}/file/${name}/download`).then(resp => {
            if (resp.ok) {
                const type = resp.data.type === 'application/pdf' ? 'PDF' : 'JPEG'
                if(download) {
                    downloadFile(name, type, resp.data.data);
                }else{
                    const blob = getBlob(name, type, resp.data.data);
                    const fileURL = URL.createObjectURL(blob);
                    window.open(fileURL);
                }
            }
        }).finally(() => {
            this.fetching = false;
        });
    }
}

export default ClaimsListStore;
